module.exports = __webpack_public_path__ + "media/src/images/icons/three_dots-9ffca6d634de89d4cc3e3e167af6f4a9.svg";